/**************************
 Lobby Console
 **************************/

var LobbyConsole = function (d) {
    this.setDebugLevel(d);
};

LobbyConsole.prototype.EMERGENCY = 0;  // Emergency: system is unusable
LobbyConsole.prototype.ALERT     = 1;  // Alert: action must be taken immediately
LobbyConsole.prototype.CRITICAL  = 2;  // Critical: critical conditions
LobbyConsole.prototype.ERROR     = 3;  // Error: error conditions
LobbyConsole.prototype.WARNING   = 4;  // Warning: warning conditions
LobbyConsole.prototype.NOTICE    = 5;  // Notice: normal but significant condition
LobbyConsole.prototype.INFO      = 6;  // Informational: informational messages
LobbyConsole.prototype.SUCCESS   = 7;  // Success: information
LobbyConsole.prototype.DEBUG     = 8;  // Debug: Show all information
LobbyConsole.prototype.DISABLED  = 9;  // Disabled: Don't show any debug

LobbyConsole.prototype.setDebugLevel = function(d) {
    if (d != undefined && d <= this.DISABLED) {
        this.debugLevel = d;
    } else {
        this.debugLevel = this.DISABLED;
    }
};

LobbyConsole.prototype.emergency = function(msg) {
    if (this.debugLevel <= this.EMERGENCY) {
        this.log('%c'+ msg, 'color:#FF0000;background-color:#FFE0E0');
    }
};

LobbyConsole.prototype.alert = function(msg) {
    if (this.debugLevel <= this.ALERT) {
        this.log('%c'+ msg, 'color:#C40000;background-color:#FFE0E0');
    }
};

LobbyConsole.prototype.critical = function(msg) {
    if (this.debugLevel <= this.CRITICAL) {
        this.log('%c'+ msg, 'color:#E0345F;background-color:#FFE0E0');
    }
};

LobbyConsole.prototype.error = function(msg) {
    if (this.debugLevel <= this.ERROR) {
        this.log('%c'+ msg, 'color:#FF0000');
    }
};

LobbyConsole.prototype.warning = function(msg) {
    if (this.debugLevel <= this.WARNING) {
        this.log('%c'+ msg, 'color:#C4AD00');
    }
};

LobbyConsole.prototype.notice = function(msg) {
    if (this.debugLevel <= this.NOTICE) {
        this.log('%c'+ msg, 'color:#0000FF');
    }
};

LobbyConsole.prototype.info = function(msg) {
    if (this.debugLevel <= this.INFO) {
        this.log('%c'+ msg, 'color:#666666');
    }
};

LobbyConsole.prototype.success = function(msg) {
    if (this.debugLevel <= this.SUCCESS) {
        this.log('%c'+ msg, 'color:#4F8A10');
    }
};

LobbyConsole.prototype.debug = function(msg) {
    if (this.debugLevel <= this.DEBUG) {
        this.log('%c'+ msg, 'color:#000000');
    }
};

LobbyConsole.prototype.log = function () {
    if (typeof window.console != 'undefined'
     && typeof window.console.log != 'undefined') {

        console.log.apply(console, arguments);
    }
};